import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";

export const LangToggle = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="flex border border-[#D4AF37]/40 text-xs tracking-widest" data-testid="lang-toggle">
      {["fr", "en"].map((l) => (
        <button key={l} data-testid={`lang-${l}-btn`} onClick={() => setLang(l)}
          className={`px-3 py-1.5 uppercase transition-colors duration-300 ${lang === l ? "bg-[#D4AF37] text-[#050B14]" : "text-[#D4AF37] hover:bg-[#D4AF37]/10"}`}>
          {l}
        </button>
      ))}
    </div>
  );
};

export const Brand = () => (
  <Link to="/" data-testid="brand-link" className="font-display text-xl sm:text-2xl tracking-[0.2em] text-[#D4AF37] whitespace-nowrap">
    JOLLY ROGER <span className="hidden sm:inline">LTD</span>
  </Link>
);

export default function Header() {
  const { t } = useLang();
  const links = [["#bateau", t.nav_boat], ["#excursions", t.nav_excursions]];
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#050B14]/60 backdrop-blur-xl border-b border-white/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 sm:px-10 h-20 flex items-center justify-between gap-4">
        <Brand />
        <nav className="hidden md:flex items-center gap-10 text-sm tracking-wider text-slate-300">
          {links.map(([href, label]) => (
            <a key={href} href={href} data-testid={`nav-${href.slice(1)}`} className="hover:text-[#D4AF37] transition-colors duration-300">{label}</a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <LangToggle />
          <a href="#reserver" data-testid="nav-book-btn"
            className="hidden sm:inline-block bg-[#D4AF37] text-[#050B14] px-5 py-2.5 text-sm font-medium tracking-wider hover:bg-[#e6c55a] transition-colors duration-300">
            {t.nav_book}
          </a>
        </div>
      </div>
    </header>
  );
}
